








































































import {
  Vue,
  Component,
  Prop,
  Inject,
  Watch,
} from "@/shared/vuepack";
import _ from "lodash";
import UsStateSelector from "@/shared/components/UsStateSelector.vue";
import { Validator } from "vee-validate";
import { umbMaximumAddressLineLength } from "@/shared/custodianSettings/employee/umb";
import { getLobSuggestions } from "@/shared/api/userService";
import { useNotifierStore } from "@/shared/store/notifier";


@Component({
  components: {
    UsStateSelector,
  }
})
export default class PoAwareAddress extends Vue {
  notifierStore = useNotifierStore();

  addressLineMax = umbMaximumAddressLineLength;

  @Prop()
  value;

  @Prop({ default: false })
  useLobApi: boolean;

  @Prop()
  disallowPoBox: boolean;

  @Prop({ required: true })
  id: string;

  @Prop()
  disabled: boolean;

  @Inject() $validator: Validator;

  suggestions = [];

  addressModel = {
    addressLine1: "",
    addressLine2: "",
    state: "",
    zip: "",
    city: "",
  };

  addressValidator (required) {
    return { isNotPoBox: this.disallowPoBox, required, max: this.addressLineMax, resemblesAddressLine: true };
  }

  @Watch("value")
  onValueChange () {
    this.addressModel = { ...this.value };
  }

  debouncedSearchFunction = _.debounce(newText => this.getAddress(newText), 600);

  async getAddress (newText) {
    this.$emit("input", this.addressModel);
    if (this.selectingAddress) {
      this.selectingAddress = false;
      return;
    }
    if (newText !== undefined && newText !== "") {
      try {
        const res = await getLobSuggestions(newText);
        if (res.data.suggestions !== null) {
          this.suggestions = res.data.suggestions.map(
              p => ({ ...p, fullAddress: `${p.addressLine1} ${p.city}, ${p.state} ${p.zip}` })
          );
        }
      } catch (error) {
        this.handleError(error);
      }
    }
  }

  selectingAddress = false;

  addressSelected (selectedAddress) {
    this.selectingAddress = true;
    this.addressModel = {
      ...this.addressModel,
      addressLine1: selectedAddress.addressLine1,
      city: selectedAddress.city,
      state: selectedAddress.state,
      zip: selectedAddress.zip,
    };

    const typeaheadRef = this.$refs.typeahead as any;
    typeaheadRef.inputValue = this.addressModel.addressLine1;
  }

  mounted () {
    this.onValueChange();
    this.checkIfPoBox();
  }

  onInput () {
    if (this.useLobApi) {
      this.$emit("lob-selection", false, this.id);
    }
    this.$emit("input", this.addressModel);
  }

  onPrimaryAddressInput (text) {
    this.$emit("lob-selection", false, this.id);
    this.debouncedSearchFunction(text.trim());
  }

  checkIfPoBox () {
    const mailingAddress1Name = `${this.id}.Address line 1`;
    const mailingAddress2Name = `${this.id}.Address line 2`;
    let address1 = true;
    let address2 = true;
    const addressModel = this.addressModel;
    if (addressModel.addressLine1 && addressModel.addressLine1.length > 0) {
      this.$validator.validate(mailingAddress1Name, addressModel.addressLine1)
          .then(address => address1 = address);
    }

    if (addressModel.addressLine2 && addressModel.addressLine2.length > 0) {
      this.$validator.validate(mailingAddress2Name, addressModel.addressLine2)
          .then(address => address2 = address);
    }
    this.$emit("address-is-po", !(address1 || address2));
  }

  hasError (name) {
    const scopedId = `${this.id}.${name}`;
    return this.$validator.errors.has(scopedId);
  }

  getError (name) {
    const scopedId = `${this.id}.${name}`;
    return this.$validator.errors.first(scopedId);
  }

  get isFormDisabled () {
    return this.disabled && this.disabled === true;
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.showError(
        (err && err.errorMessage) ||
        "Error processing your request. Please try again later"
    );
  }
}
